// PW TOOLS JS FRONT
window.showMessage = showMessage
window.reloadSelect = reloadSelect


function reloadSelect() {
    $('.select-custom select').parent().find('ul').remove().find('span').remove();
    $('.select-custom select').parent().find('span').remove();
    $('.select-custom select').each(function () {
        const dropdown = $('<div />').addClass('dropdown selectDropdown')

        $(this).wrap(dropdown)

        const label = $('<span />').text($(this).attr('placeholder')).insertAfter($(this))
        const list = $('<ul class="list-select" />')

        $(this)
            .find('option')
            .each(function () {
                list.append($('<li />').append($('<a />').text($(this).text())))
            })

        list.insertAfter($(this))

        if ($(this).find('option:selected').length) {
            label.text($(this).find('option:selected').text())
            list.find('li:contains("' + $(this).find('option:selected').text() + '")').addClass('active')
            $(this).parent().addClass('filled')
        }
    })

    $(document).on('click touch', '.selectDropdown ul li a', function (e) {
        e.preventDefault()
        const dropdown = $(this).parent().parent().parent()
        const active = $(this).parent().hasClass('active')
        const label = active ? dropdown.find('select').attr('placeholder') : $(this).text()

        dropdown.find('option').prop('selected', false)
        dropdown.find('ul li').removeClass('active')

        dropdown.toggleClass('filled', !active)
        dropdown.children('span').text(label)

        if (!active) {
            dropdown.find('option:contains("' + $(this).text() + '")').prop('selected', true)
            $(this).parent().addClass('active')
        }

        $(dropdown[0]).find('select').change();
        dropdown.removeClass('open')
    })

    $('.dropdown > span').on('click touch', function (e) {
        const self = $(this).parent()
        self.toggleClass('open')
    })

    $(document).on('click touch', function (e) {
        const dropdown = $('.dropdown')
        if (dropdown !== e.target && !dropdown.has(e.target).length) {
            dropdown.removeClass('open')
        }
    })
}

// INPUT FILE CUSTOM
var inputFileItems = document.querySelectorAll('.input-file')

for (var i = 0; i < inputFileItems.length; i++) {
    var fileInput = inputFileItems[i].children[0],
        button = inputFileItems[i].children[1],
        the_return = inputFileItems[i].children[2]

    button.addEventListener('keydown', function (event) {
        if (event.keyCode == 13 || event.keyCode == 32) {
            this.previousElementSibling.focus()
        }
    })

    button.addEventListener('click', function (event) {
        this.previousElementSibling.focus()
        return false
    })

    fileInput.addEventListener('change', function (event) {
        var this_return = this.nextElementSibling.nextElementSibling
        this_return.innerHTML = this.value.replace('C:\\fakepath\\', ' ')
    })
} // END

// Fonction qui affiche une notification en bas du header pendant 3 secondes
// type : ( string ) class qu'aura l'élément ajouté ( valid, error ou delete )
// message : ( string ) message affiché
function showMessage(type, message) {
    var alert = $('<p>')
    alert.addClass('msg-info flash')
    alert.addClass(type)
    alert.html(message)

    $('body').append(alert)

    setTimeout(function () {
        alert.addClass('open')
    }, 100)

    setTimeout(function () {
        alert.removeClass('open')
    }, 3000)

    setTimeout(function () {
        alert.remove()
    }, 3500)
}

$(document).ready(function () {

    reloadSelect();

    // RETOUR EN HAUT - créer balise #gotop
    $('#gotop').on('click', function () {
        //
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        return false
    })

    // BOUTON TOGGLE MAIN NAV
    $('.toggle-nav').click(function () {
        $(this).toggleClass('menu-open')
        $('.menu').toggleClass('showing-nav')
        return false
    })

    // BOUTON TOGGLE SEARCH
    $('.toggle-search').click(function () {
        $(this).toggleClass('search-mobile-on')
        $('.form-search').toggleClass('search-open')
        return false
    })

    // POPUP
    $('*[data-popup]').click(function () {
        $('body').addClass('mode-popup')
        $('#' + $(this).attr('data-popup')).addClass('open')

        /*

        $(document).mouseup(function(e){
            let container = $(".popup");

            if (!container.is(e.target) && container.has(e.target).length === 0)
            {
                $('body').removeClass('mode-popup')
                $('.popup').removeClass('open')
            }
        });

        */
    })

    // CLOSE POPUP
    $('.close-popup').click(function () {
        $('body').removeClass('mode-popup')
        $(this).parent('.popup').removeClass('open')
    })

    $('.need-help-button').click(function () {
        $('body').addClass('mode-popup')
        $('.need-help-window').addClass('open')

        $(document).mouseup(function (e) {
            let container = $(".need-help-window");

            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('body').removeClass('mode-popup')
                $('.need-help-window').removeClass('open')
            }
        });
    })

    $('.need-help-window .icon-close').click(function () {
        $('body').removeClass('mode-popup')
        $('.need-help-window').removeClass('open')
    })

    // ONGLETS
    $('*[data-onglet]').click(function () {
        $('.nav-onglets > a').removeClass('actif')
        $('.onglet-content').removeClass('open')
        $(this).addClass('actif')
        $('#' + $(this).attr('data-onglet')).addClass('open')
    })

    // TOGGLE SECTION
    $('.toggle-item').on('click', '> .toggle-launcher', function () {
        if ($(this).parent().hasClass('open')) {
            $(this).parent().removeClass('open')
        } else {
            $('.toggle-section .toggle-item.open').removeClass('open')
            $(this).parent().addClass('open')
        }

        return false
    })

    // RECUP EMAIL NEWSLETTER POPUP
    $('[data-popup-news="inscrinews"]').on('click', function () {
        if ($('#recup-email-news:valid').length != 0) {
            var email = $('#recup-email-news').val()
            $('#email-newsletter').attr('value', email)
            $('body').addClass('mode-popup')
            $('#' + $(this).attr('data-popup-news')).addClass('open')
        }
    })

    $('.open-search').click(function () {
        $('.form-search').addClass('open')
    })

    $('.close-search').click(function () {
        $('.form-search').removeClass('open')
    })

    $('.number-with-increment label span').html($(".number-with-increment input").val())

    $(".number-with-increment input").change(function () {
        if ($(this).val() < 50) $(".number-with-increment input").val(50);
    })

    $('.number-with-increment .remove').click(function () {
        let value = parseInt($(".number-with-increment input").val())

        if (value > 50) {
            value -= 50
            if (value < 50) value = 50;
            $(".number-with-increment input").val(value)
            $('.number-with-increment label span').html($(".number-with-increment input").val())

        }
    })


    $('.number-with-increment .add').click(function () {
        let value = parseInt($(".number-with-increment input").val())
        value += 50
        $(".number-with-increment input").val(value)
        $('.number-with-increment label span').html($(".number-with-increment input").val())
    })

    $('.short-loc-popup .form .validate').click(function () {
        let step = $(this).parent().attr('data-step')
        $(this).parent().removeClass('show')
        $(this).parent().next().addClass('show')
        $(`.steps .step-${step}`).addClass('complete')
    })

    $('.steps .step').click(function () {
        let step = $(this).attr('data-step')

        if ($(this).hasClass('complete')) {
            $('.short-loc-popup .form').removeClass('show')
            $(this).removeClass('complete')
            $(this).next().removeClass('complete')
            $(`.form-${step}`).addClass('show');
        }
    })

    if ($('.toggle').hasClass('open')) {
        $('.open > .content').show()
    }
}) // FIN DOCUMENT READY

$('.toggle .toggle-title').click(function () {
    if (!$(this).parent().hasClass('open')) {
        $('.toggle').removeClass('open')
        $('.toggle .content').hide('normal')
        $(this).parent().toggleClass('open')
        $(this).next().toggle('normal')
    }
    else {
        $('.toggle').removeClass('open')
        $(this).next().hide('slow')
    }
})

// Flatpickr
$(".flatpickr").flatpickr({
    dateFormat: ('Y-m-d'),
    altInput: true,
    allowInput: true,
    altFormat: ('d/m/Y'),
    defaultDate: null,
    minDate: "today",
    "locale": "fr"
});

// Flatpickr info personnelles
$(".flatpickr-info").flatpickr({
    dateFormat: ('Y-m-d'),
    altInput: true,
    allowInput: true,
    altFormat: ('d/m/Y'),
    defaultDate: null,
    minDate: null,
    maxDate: "today",
    "locale": "fr"
});

new SlimSelect({
    select: '#popSelAgence',

    settings: {
        searchPlaceholder: 'Recherche',
      }
})

$('.card-carousel').slick({
    autoplay: true,
    dots: false,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
})

/* Sidebar search activation et fermeture

$('.update-research').click(function(){
    $('.sidebar-back').addClass('open')
    $('body').addClass('mode-popup')
})

$(document).mouseup(function(e){
    console.log('tedt')
    let sidebar = $(".sidebar-back");

    if (!sidebar.is(e.target) && sidebar.has(e.target).length === 0)
    {
        $('body').removeClass('mode-popup')
        $('.sidebar-back').removeClass('open')
    }
});
*/

function gestionScroll() {
    if ($(window).scrollTop() > 0) {
        $('header').addClass('scroll');
    } else {
        $('header').removeClass('scroll');
    }
}

$(document).ready(function() {
    gestionScroll();
});


$(window).scroll(function() {
    gestionScroll();
});
